module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9XBP0T/tc-custom/9781488007958.jpg?1743867524906",
      "alt": "This image is the cover for the book Counterfeit Courtship"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Counterfeit Courtship\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_c('b', [_vm._v("Second Chance Reunion")])]), _c('i', [_c('b')]), _c('br'), _c('br'), _vm._v("Returning home, Confederate hero Colonel Graham Talbot faces his toughest battle yetavoiding the marriage-minded young ladies in town vying for his attentions. With a stepmother and orphaned niece to support, the penniless soldier has no intention of marrying. Neither does the woman he once loved, his next-door neighbor Ellie Anderson. But Ellie has a proposal of her own: a pretend courtship to keep their unwanted admirers at bay. "), _c('br'), _c('br'), _vm._v("Ellie's unpredictable childhood left her determined to safeguard her independenceand her plantation. Blaming herself for driving Graham away to war, she devises a plan to help them both. But when it goes awry, Ellie will face a choice: save her beloved propertyor trust in a relationship that's becoming undeniably real.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christina Miller\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Christina Miller left her nursing job to become a writer and editor so she could read for a living. With two theology degrees, she is a pastor’s wife and worship leader. She enjoys exploring museums and hosting Dinner Church in her home. She lives on her family farm with her husband of thirty-three years. Contact Christina through Love Inspired, Facebook.com/christinalinstrotmiller or @clmillerbooks."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0